//--- Canvas Carousel ---
jQuery('.canvas-carousel-true').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    SlidesToScroll: 1,
    arrows: true,
    prevArrow: '<button class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><img src="//cdn.shopify.com/s/files/1/0522/6456/6947/t/1/assets/arrow-left.png?v=62735654954523501141609767517"></button>',
    nextArrow: '<button class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><img src="//cdn.shopify.com/s/files/1/0522/6456/6947/t/1/assets/arrow-right.png?v=166335568677087149041609767528"></button>',
    responsive: [
                  {
                    breakpoint: 1280,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }

                ]
  });

//--- Art Carousel ---
jQuery('.art-carousel-true').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    SlidesToScroll: 1,
    arrows: true,
    prevArrow: '<button class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><img src="//cdn.shopify.com/s/files/1/0522/6456/6947/t/1/assets/arrow-left.png?v=62735654954523501141609767517"></button>',
    nextArrow: '<button class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><img src="//cdn.shopify.com/s/files/1/0522/6456/6947/t/1/assets/arrow-right.png?v=166335568677087149041609767528"></button>',
    responsive: [
                  {
                    breakpoint: 1280,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }

                ]
  });

const language = document.documentElement.lang;


const ctLogo = document.querySelector('.ct-logo img');
if(language == 'fr'){
 
  ctLogo.setAttribute("src", `//cdn.shopify.com/s/files/1/0522/6456/6947/t/1/assets/ct-logo-fr.png?v=125009856501184470531613156283`);

 

}else{
  
  ctLogo.setAttribute("src", `//cdn.shopify.com/s/files/1/0522/6456/6947/t/1/assets/ct-logo.png?v=39936053798437864171609765173`);
   
   
}


const proposFirstPara = document.querySelector(".sc-pkvvt.cbrLgP.pf-13c7aa34");
const proposSecondPara = document.querySelector(".sc-pkvvt.cbrLgP.pf-aa0058c6");
const proposThirdPara = document.querySelector(".sc-pkvvt.cbrLgP.pf-2ff57c3f");

if(window.location.pathname=="/en/pages/a-propos"){

proposFirstPara.style.display = 'none';
proposSecondPara.style.display = 'none';
proposThirdPara.style.display = 'none';

}

const contactBtn = document.querySelector(".sc-pBlUC.jBiRe.pf-55a5d3dc");
if(contactBtn){
contactBtn.innerHTML = "<span>ENVOYER</span>";
}



// const indexTemplate = document.querySelector('.template-index');
// const headerSection = document.querySelector('[data-section-id="header"]');

// if(indexTemplate){
// headerSection.classList.add('black-bg');

// }
const proposContainer = document.getElementById('MainContent');

if(window.location.pathname=="/pages/a-propos" || window.location.pathname=="/en/pages/a-propos"){
  proposContainer.style.paddingTop=0;
//   headerSection.classList.add('black-bg');
}
